function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6,12 C9.3137085,12 12,9.3137085 12,6 C12,2.6862915 9.3137085,0 6,0 C2.6862915,0 0,2.6862915 0,6 C0,9.3137085 2.6862915,12 6,12 Z M8.57361702,7.8034383 C8.78658723,8.01640851 8.78658723,8.36119149 8.57361702,8.57361702 C8.46740426,8.67982979 8.32796596,8.73320851 8.18852766,8.73320851 C8.04908936,8.73320851 7.90965106,8.67982979 7.8034383,8.57361702 L6.16667234,6.93685106 L4.52990638,8.57361702 C4.42369362,8.67982979 4.28425532,8.73320851 4.14481702,8.73320851 C4.00537872,8.73320851 3.86594043,8.67982979 3.75972766,8.57361702 C3.54675745,8.36119149 3.54675745,8.01640851 3.75972766,7.8034383 L5.39649362,6.16667234 L3.75972766,4.52990638 C3.54675745,4.31693617 3.54675745,3.97215319 3.75972766,3.75972766 C3.97269787,3.54675745 4.31693617,3.54675745 4.52990638,3.75972766 L6.16667234,5.39649362 L7.8034383,3.75972766 C8.01640851,3.54675745 8.36064681,3.54675745 8.57361702,3.75972766 C8.78658723,3.97215319 8.78658723,4.31693617 8.57361702,4.52990638 L6.93685106,6.16667234 L8.57361702,7.8034383 Z",
  id: "Icon-/-Clear-rating_path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Clear-rating",
  transform: "translate(-4.000000, -4.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_clear",
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "Icon-/-Clear-rating_mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Icon-/-Clear-rating_path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero",
  xlinkHref: "#Icon-/-Clear-rating_path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "UI-Color-/-Default-Color",
  mask: "url(#Icon-/-Clear-rating_mask-2)",
  fill: "#595959"
}))));

function SvgIconClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_clear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClear);
export default __webpack_public_path__ + "static/media/icon_clear.52013779.svg";
export { ForwardRef as ReactComponent };